import { render, staticRenderFns } from "./productsGraphs.vue?vue&type=template&id=2f086c12"
import script from "./productsGraphs.vue?vue&type=script&lang=js"
export * from "./productsGraphs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports